/**
 * Creates a Bearer token from the given token.
 *
 * @param {string} token - the input token
 * @return {string} the Bearer token generated from the input token
 */
export function createBearerFromToken(token: string) {
  return `Bearer ${token}`;
}
